import { FeventDate } from '@shared/types';

import { DAY_LIST } from './dayList';
import { addKstDays, toKstParts } from './kstDate';

//* 모든 날짜 표시는 열람자 타임존과 무관하게 한국 시간(KST) 기준으로 고정한다.
//* 장례 일정(별세·입관·발인)은 한국 달력의 고정 날짜라 해외에서 열어도 하루가 밀리면 안 됨.

interface IDateFormatOptions {
  dateSeparater?: string; // default: "-"
  timeSeparater?: string; // default: ":"
  contains?: {
    year?: boolean; // default: true
    month?: boolean; // default: true
    date?: boolean; // default: true
    day?: boolean; // default: false
    amPm?: boolean; // default: false
    hours?: boolean; // default: false
    minutes?: boolean; // default: false
    seconds?: boolean; // default: false
  };
}

const prependZero = (num: number): string => (num < 10 ? `0${num}` : String(num));

const getHours = (hours: number, amPm: '' | '오전' | '오후') => {
  let result: number;
  switch (amPm) {
    case '':
      result = hours;
      break;
    case '오전':
      result = hours;
      break;
    case '오후':
      result = hours === 12 ? hours : hours - 12;
      break;
    default:
      result = hours;
      break;
  }
  return prependZero(result);
};

export const formatDate = (
  targetDate: Date | null | undefined,
  options?: IDateFormatOptions,
): string => {
  if (!targetDate) return '미정';
  targetDate = new Date(targetDate);

  // default options
  let dateSeparater = '-',
    timeSeparater = ':',
    yearOpt = true,
    monthOpt = true,
    dateOpt = true,
    dayOpt = false,
    // amPmOpt = false,
    hoursOpt = false,
    minutesOpt = false,
    secondsOpt = false;

  if (options) {
    dateSeparater = options.dateSeparater ?? dateSeparater;
    timeSeparater = options.timeSeparater ?? timeSeparater;
    if (options.contains) {
      yearOpt = options.contains.year ?? yearOpt;
      monthOpt = options.contains.month ?? monthOpt;
      dateOpt = options.contains.date ?? dateOpt;
      dayOpt = options.contains.day ?? dayOpt;
      // amPmOpt = options.contains.amPm ?? amPmOpt;
      hoursOpt = options.contains.hours ?? hoursOpt;
      minutesOpt = options.contains.minutes ?? minutesOpt;
      secondsOpt = options.contains.seconds ?? secondsOpt;
    }
  }

  const kst = toKstParts(targetDate);
  const year = yearOpt ? prependZero(kst.year) : '';
  const month = monthOpt ? prependZero(kst.month) : '';
  const date = dateOpt ? prependZero(kst.date) : '';
  const day = dayOpt ? `(${DAY_LIST[kst.day]})` : '';
  // const amPm = amPmOpt ? getAmPm(targetDate) : '';
  const hours = hoursOpt ? prependZero(kst.hours) : '';
  const minutes = minutesOpt ? prependZero(kst.minutes) : '';
  const seconds = secondsOpt ? prependZero(kst.seconds) : '';

  let result = '';

  // Year
  result += year;
  // Month
  result += result.length !== 0 && month.length !== 0 ? dateSeparater : '';
  result += month;
  // Date
  result += result.length !== 0 && date.length !== 0 ? dateSeparater : '';
  result += date;
  // Day
  result += day;

  result +=
    result.length !== 0 &&
    (hours.length !== 0 || minutes.length !== 0 || seconds.length !== 0)
      ? ' '
      : '';

  // amPm
  // result += amPm + ' ';
  // Hours
  result += hours;
  // Minutes
  // result += result.length !== 0 && minutes.length !== 0 ? timeSeparater : '';
  result += result.length !== 0 && minutes.length !== 0 ? timeSeparater ?? '시 ' : '';
  result += minutes;
  result +=
    result.length !== 0 && minutes.length !== 0 ? (timeSeparater ? '' : '분 ') : '';

  // Seconds
  // result += result.length !== 0 && seconds.length !== 0 ? timeSeparater : '';
  result += seconds;

  return result;
};

const WEEKDAY = ['일', '월', '화', '수', '목', '금', '토'];

export const formatFeventDateString = (
  fDate: FeventDate,
  timeShow = true,
  dayShow = false,
) => {
  const dateArr: string[] = [];
  if (fDate && fDate.date) {
    //* 한국 시간 기준 고정(해외 열람·공유 시 하루 밀림 방지)
    const kst = toKstParts(fDate.date);
    dateArr.push(`${kst.year}년`);
    dateArr.push(`${kst.month}월`);
    dateArr.push(`${kst.date}일${dayShow ? `(${WEEKDAY[kst.day]})` : ''}`);
    if (timeShow) {
      if (fDate.timeDefined) {
        dateArr.push(`${prependZero(kst.hours)}시`);
        dateArr.push(`${prependZero(kst.minutes)}분`);
      } else {
        dateArr.push('시간 미정');
      }
    }
  } else {
    dateArr.push('');
  }
  return dateArr.join(' ');
};

export const getAfter5days = (date: Date | null) => {
  if (date) {
    return addKstDays(date, 5);
  }
};
